import { render, staticRenderFns } from "./CarlosXo.vue?vue&type=template&id=a16ca194&scoped=true&"
import script from "./CarlosXo.vue?vue&type=script&lang=js&"
export * from "./CarlosXo.vue?vue&type=script&lang=js&"
import style0 from "./CarlosXo.vue?vue&type=style&index=0&id=a16ca194&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16ca194",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
